/**
 * Copyright (c) 2026, CYBRA Corp. All rights reserved.
 */
export enum PagePermissionType {
  //Pages navigated to via the "System" Menu
  HomePage = 'home',
  UsersPage = 'system-users',
  PeoplePage = 'system-people',
  RoleManagerPage = 'system-rolemanager',
  InfrastructurePage = 'system-infrastructure',
  AssetsPage = 'system-assets',
  SitesPage = 'system-sites',
  GtinValidationSetsPage = 'gtin-validation-sets',
  TriggersPage = 'system-triggers',
  ReactionsPage = 'system-reactions',
  RulesPage = 'system-rules',
  SettingsPage = 'system-settings',
  LicensingPage = 'system-licensing',
  HistoryPage = 'history',
  HealthMonitorPage = 'health-monitor',
  WorkflowsPage = 'workflows-page',
  SwaggerApiPage = 'swagger-api',

  //Infrastructure Sub Pages for each Entity Types/Sub Types
  InfrastructureAntennasPage = 'system-infrastructure-antennas',
  InfrastructureAssetsPage = 'system-infrastructure-assets',
  InfrastructurePeoplePage = 'system-infrastructure-people',
  InfrastructureDevicesPage = 'system-infrastructure-devices',
  InfrastructureDriverObjectsPage = 'system-infrastructure-drivers',
  InfrastructureLocationsPage = 'system-infrastructure-locations',
  InfrastructureReadersPage = 'system-infrastructure-readers',
  InfrastructureRfidEncodingSchemesPage = 'system-infrastructure-rfid-encoding-schemes',
  InfrastructureServerObjectsPage = 'system-infrastructure-server-objects',
  InfrastructureServicesPage = 'system-infrastructure-services',
  InfrastructureTagsPage = 'system-infrastructure-tags',
  InfrastructureZonesPage = 'system-infrastructure-zones',
  CustomFieldsPage = 'app-custom-fields',

  //Pages navigated to via the Dashboard
  LocatePage = 'dashboard-locate',
  SecurityPage = 'dashboard-alerts',
  ReportsPage = 'dashboard-locate-reports',
  HelpPage = 'dashboard-locate-help',
  MonitorAssetsPage = 'monitor-assets-page',
  MonitorLocationPage = 'monitor-location-page',
  MonitorTagsPage = 'monitor-tags-page',
  MonitorZonePage = 'monitor-zone-page',

  // Set MMC Affiliates Page
  SetMmcAffiliatesPage = 'mmc-set-affiliates-page',

  // Portal Validation Page for internal Edgefinity Orders against SGTINs
  DemoOrderPortalValidationPage = 'demo-order-portal-validation-page',

  // Customer specific Pages
  KissPrintPage = 'kiss-print-page',
  KissPortalValidationPage = 'kiss-portal-validation-page',
  KissOutboundValidationPage = 'kiss-outbound-validation-page',

  // Denver Mattress Specific Pages
  DenverMattressPortalValidationPage = 'denver-mattress-portal-validation-page',

  // Buchanan Specific Pages
  BuchananUploadProductPage = 'buchanan-upload-product-page',
  BuchananBulkPrintPage = 'buchanan-bulk-print-page',
  BuchananPrintPage = 'buchanan-print-page',

  // O'Neil Specific Pages
  ONeilCartonPortalPages = 'oneil-carton-portal-validation',

  // Portal Validation Page for internal Edgefinity Orders against SGTINs
  CartonAuditPortalPage = 'carton-audit-portal-page',

  // Ablenet Specific Pages
  AbleNetShipmentValidationPage = 'ablenet-shipment-validation',
  AbleNetReturnDevicesValidationPage = 'ablenet-return-devices-validation',

  ApiTokenPage = 'app-api-token',

  DataMappingPage = 'app-data-mapping-hdr',
  DataMappingPageUpload = 'app-data-mapping-upload',

  ZoneAssignedAssetsPage = 'zone-assigned-assets-page'

}
